// Canonical streaming platform mapping (color palette + aliases).
// Maps a noisy LLM-extracted name to a canonical key + brand color.

const CANONICAL = {
  espn_plus: { label: "ESPN+", color: "#EAA300" },
  espn:      { label: "ESPN", color: "#CC0000" },
  peacock:   { label: "Peacock", color: "#7D26C9" },
  max:       { label: "Max", color: "#002BE7" },
  prime:     { label: "Prime Video", color: "#00A8E1" },
  apple_tv:  { label: "Apple TV+", color: "#1A1A1A" },
  youtube_tv:{ label: "YouTube TV", color: "#FF0000" },
  paramount_plus: { label: "Paramount+", color: "#0064FF" },
  hulu:      { label: "Hulu", color: "#1CE783" },
  nbc:       { label: "NBC", color: "#1A1A1A" },
  cbs:       { label: "CBS", color: "#004B87" },
  fox:       { label: "FOX", color: "#0033A0" },
  abc:       { label: "ABC", color: "#FF5E3A" },
  tnt:       { label: "TNT", color: "#F04E23" },
  tbs:       { label: "TBS", color: "#1F6FB3" },
  usa:       { label: "USA Network", color: "#0064B1" },
  nfl_net:   { label: "NFL Network", color: "#013369" },
  nba_tv:    { label: "NBA TV", color: "#1D428A" },
  mlb_net:   { label: "MLB Network", color: "#002D72" },
  nhl_net:   { label: "NHL Network", color: "#000000" },
  fs1:       { label: "FS1", color: "#003C7E" },
  fs2:       { label: "FS2", color: "#003C7E" },
  generic:   { label: "TV", color: "#111111" },
};

export function platformInfo(raw) {
  if (!raw) return CANONICAL.generic;
  const s = String(raw).toLowerCase().replace(/\s+/g, "");
  // ESPN App / Hulu + Live TV / Fubo
  if (s.includes("directv") || s.includes("dtvstream") || s === "directvstream") return { label: "DIRECTV Stream", color: "#00549E" };
  if (s.includes("espnapp")) return { label: "ESPN App", color: "#CC0000" };
  if (s.includes("hulu+livetv") || s.includes("huluwithlivetv") || s.includes("hululivetv")) return { label: "Hulu + Live TV", color: "#1CE783" };
  if (s.includes("fubo")) return { label: "Fubo", color: "#E8194A" };
  if (s.includes("espn+") || s.includes("espnplus")) return CANONICAL.espn_plus;
  if (s.includes("espn")) return CANONICAL.espn;
  if (s.includes("peacock")) return CANONICAL.peacock;
  if (s === "max" || s.includes("hbomax") || s.includes("hbo") || s.includes("warnerbrosdiscovery")) return CANONICAL.max;
  if (s.includes("primevideo") || s === "prime" || s.includes("amazon")) return CANONICAL.prime;
  if (s.includes("appletv") || s.includes("apple")) return CANONICAL.apple_tv;
  if (s.includes("youtubetv") || s.includes("youtube")) return CANONICAL.youtube_tv;
  if (s.includes("paramount")) return CANONICAL.paramount_plus;
  if (s.includes("hulu")) return CANONICAL.hulu;
  if (s.includes("nflnetwork") || s === "nfln" || s === "nfln") return CANONICAL.nfl_net;
  if (s.includes("nbatv")) return CANONICAL.nba_tv;
  if (s.includes("mlbnetwork")) return CANONICAL.mlb_net;
  if (s.includes("nhlnetwork")) return CANONICAL.nhl_net;
  if (s === "nbc" || s.includes("nbcsports")) return CANONICAL.nbc;
  if (s === "cbs" || s.includes("cbssports")) return CANONICAL.cbs;
  if (s === "fox" || s.includes("foxsports") || s.includes("foxtv")) return CANONICAL.fox;
  if (s === "abc") return CANONICAL.abc;
  if (s === "tnt") return CANONICAL.tnt;
  if (s === "tbs") return CANONICAL.tbs;
  if (s.includes("usanetwork") || s === "usa") return CANONICAL.usa;
  if (s === "fs1") return CANONICAL.fs1;
  if (s === "fs2") return CANONICAL.fs2;
  return { label: String(raw), color: CANONICAL.generic.color };
}
